export function getScaleDir(containerSize: number, objectSize: number): number {
  return containerSize < objectSize ? (containerSize > objectSize ? 1 : -1) : -1;
}
